import React, { Component } from "react";
import { Form, InputNumber, Icon, Button, Layout, Row, Col, Modal } from 'antd';
import { graphql, compose } from 'react-apollo';
import { getSettings } from "./queries/getSettings";
import { updateSettings } from "./mutations/updateSettings";
import displayServerErrors from "../../../utilities/form/display_server_errors";
import Spinner from "../../spinner/spinner";
import "./settings.css"

const FormItem = Form.Item;

class SettingsEditForm extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue()
        }
      }
    }
  }

  async submitData() {
    try {
      this.setState({...this.state, loading: true});
      await this.props.mutate(this.mutationParams);
      Modal.success({
        title: "Settings have been updated"
      });
    } catch(response) {
      displayServerErrors(this.props.form, response)
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error) => {
      if (!error) {
        this.submitData();
      }
    });
  };

  renderPasswordResetTokenLifetimeField() {
    const { getFieldDecorator } = this.props.form;

    return (
      <FormItem label="Password Reset Token Lifetime(hours)" class="login-form">
        {getFieldDecorator('password_reset_token_lifetime', {
          initialValue: this.props.data.settings.passwordResetTokenLifetime,
        })(
          <InputNumber type="number" min={1} max={336}/>
        )}
      </FormItem>
    )
  }

  render() {
    if (this.props.data.loading) {
      return <Spinner />;
    }

    return (
      <Form onSubmit={this.onSubmit}>
        <Row>
          <Col xs={{span: 24}} lg={{offset: 1, span: 10}}>
            { this.renderPasswordResetTokenLifetimeField() }
            <div className="align-right">
              <Button onClick={() => this.props.form.resetFields()}>
                CANCEL
              </Button>
              <Button type="primary" htmlType="submit" loading={this.state.loading}>
                SAVE
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default Form.create()(
  compose(
    graphql(getSettings),
    graphql(updateSettings, {
      options: {
        update: (proxy, { data: { updateSettings } }) => {
          proxy.writeQuery({ query: getSettings, data: { settings: updateSettings.settings } });
        }
      }
    })
  )(SettingsEditForm)
);



// WEBPACK FOOTER //
// ./src/components/pages/settings/form.js